import {
  initColorSwatchesClickListener,
  redirectToCorrectProductColour,
} from '../objects/product/pdp-navigation.js';

initColorSwatchesClickListener();
void redirectToCorrectProductColour();
